import React, { useEffect, useState } from 'react';
// ✅ Corrected path: Go up one level from 'components' to 'src'
import { fetchMarkdownFilesRecursive, fetchMarkdownFileContent, saveMarkdownFile, deleteMarkdownFile } from '../api';
import Editor from './Editor';
import CreateFile from './CreateFile';
import FileTree from './FileTree';
// ✅ Corrected path: Go up one level to find the 'utils' folder
import { buildFileTree } from '../utils/fileTree';

const FileList = () => {
  const [files, setFiles] = useState([]);
  const [viewingFile, setViewingFile] = useState(null);
  const [fileContent, setFileContent] = useState('');
  const [editingFile, setEditingFile] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const refreshFiles = async () => {
    const allFiles = await fetchMarkdownFilesRecursive('content');
    setFiles(allFiles);
  };

  useEffect(() => { refreshFiles(); }, []);

  const handleView = async (filePath) => {
    setViewingFile(filePath);
    setEditingFile(null);
    try {
      const content = await fetchMarkdownFileContent(filePath);
      setFileContent(content);
    } catch (err) {
      setFileContent('Error loading file: ' + err.message);
    }
  };

  const handleEdit = (filePath) => {
    setEditingFile(filePath);
    setViewingFile(null);
  };

  const handleDelete = async (filePath) => {
    if (window.confirm(`Are you sure you want to delete ${filePath}?`)) {
      try {
        await deleteMarkdownFile(filePath);
        await refreshFiles();
      } catch (err) {
        alert('Error deleting file: ' + err.message);
      }
    }
  };

  const handleClose = () => {
    setViewingFile(null);
    setEditingFile(null);
    setShowCreateModal(false);
    setFileContent('');
  };

  const fileTreeData = buildFileTree(files);

  return (
    <div className="card">
      <h2 className="card-title">📝 Markdown Content</h2>
      <button className="button button-primary" style={{ marginBottom: 20 }} onClick={() => setShowCreateModal(true)}>
        + New File
      </button>

      <div className="file-tree-container">
        <FileTree
          treeData={fileTreeData}
          handleView={handleView}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      </div>

      {(showCreateModal || viewingFile || editingFile) && (
        <div className="modal-backdrop">
          <div className="modal-box">
            <button onClick={handleClose} className="modal-close-btn">×</button>
            <div className="modal-content">
               {showCreateModal && (
                <CreateFile 
                  onFileCreated={() => {
                    refreshFiles(); // Refresh the file list
                    handleClose();  // Close the modal
                  }} 
                />
              )}
              {viewingFile && (
                <>
                  <h3>{viewingFile.replace(/^content\//, '')}</h3>
                  <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{fileContent}</pre>
                </>
              )}
              {/* ✅ FIXED: The onSave prop now has the correct function */}
              {editingFile && (
                <Editor
                  fileName={editingFile}
                  onSave={async (file, content) => {
                    await saveMarkdownFile(file, content);
                    await refreshFiles();
                    handleClose(); // Close modal after saving
                  }}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FileList;